export const PRICE_PER_CARBON_TONE = { GB: 9.45, US: 13.4, AU: 18.1, NZ: 18.1 };
export const PRICE_PER_TREE = 0.124;
export const CARBON_OFFSET_IMPACT_PERCENTAGE = 0.01;
